import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToggleButton } from "../../ui/buttons";

const KpiCardNP = ({ statusDef, value, total, onClick, selected, icon, detail }) => {
  const count = value ? value.count : 0;
  const { color } = statusDef;

  const handleDivOnCLick = () => {
    const status = statusDef.id || null;
    onClick(status);
  };

  return (
    <ToggleButton width="100%" maxWidth="300px" border="1px solid #ccc !important" padding="5px 10px" onClick={handleDivOnCLick} isSelected={selected}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: "160px" }}>
        {icon && !detail ? <FontAwesomeIcon color={color || ""} size="lg" icon={icon} style={{ filter: "drop-shadow(0px 0px)", marginRight: "5px" }} /> : <></>}
        {detail || <></>}
        <p className="m-0 pr-1" style={{ whiteSpace: "nowrap", maxWidth: "80%", overflow: "hidden", textOverflow: "ellipsis" }}>
          {statusDef.text}
        </p>
        <div className="d-flex align-items-end justify-content-start">
          <p className="pl-1 m-0" style={{ fontWeight: "bold" }}>{`${count || 0}/${total || 0}`}</p>
        </div>
      </div>
    </ToggleButton>
  );
};

export default KpiCardNP;
